import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-login',
  templateUrl: './login-layout.component.html',
  host: {
    '[attr.tabindex]': '-1',
  },
  standalone: false,
})
export class loginLayoutComponent {}
